export const abnNoticeConstants = {
  templateType: {
    ABN_Medicare: "ABN_Medicare",
    ABN_Commercial: "ABN_Commercial",
  },
  abnOption: {
    billMedicare: "billMedicare",
    selfPay: "selfPay",
    declineService: "declineService",
    payNowAndFileInsurance: "payNowAndFileInsurance",
    selfPayNoInsurance: "selfPayNoInsurance",
    declineWithoutFinancialResponsibility:
      "declineWithoutFinancialResponsibility",
    cosmeticService: "cosmeticService",
  },
};

export const abnOptionMapping = {
  [abnNoticeConstants.abnOption.billMedicare]: "BillMedicare",
  [abnNoticeConstants.abnOption.selfPay]: "SelfPay",
  [abnNoticeConstants.abnOption.declineService]: "DeclineService",
  [abnNoticeConstants.abnOption.payNowAndFileInsurance]:
    "PayNowAndFileInsurance",
  [abnNoticeConstants.abnOption.selfPayNoInsurance]: "SelfPayNoInsurance",
  [abnNoticeConstants.abnOption.declineWithoutFinancialResponsibility]:
    "DeclineWithoutFinancialResponsibility",
  [abnNoticeConstants.abnOption.cosmeticService]: "CosmeticService",
};
